import { cache } from "lib/apolloClient";
import client from "lib/apolloClient/client";
import _ from "lodash";
import update from "immutability-helper";

import { getProjectCriteriaDetailsQuery } from "Projects/modules/ProjectQueries";
import { handleAssessmentToolResponseMutation } from "AssessmentEvaluation/modules/AssessmentEvaluationMutation";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { generateRandomId } from "Utils";
import { updateElementRemarkMutationMutation } from "Projects/modules/ProjectMutations";

const updateToolResponseInCache = ({ rowId, parentId, columnId }) => {
  cache.updateQuery(
    {
      query: getProjectCriteriaDetailsQuery,
      variables: { id: parentId, studentCourseFilters: {} },
    },
    data => {
      const toolResponses = data?.node?.toolResponses;

      const isPresent = _.some(toolResponses, item => item.rowId === rowId);
      let updatedToolResponses = toolResponses || [];
      if (isPresent) {
        updatedToolResponses = _.map(toolResponses, item => {
          if (item.rowId === rowId) {
            return {
              ...item,
              columnId,
            };
          }
          return item;
        });
      } else {
        const newResponse = {
          id: generateRandomId(),
          rowId,
          columnId,
          isDeleted: false,
          subjectiveResponse: null,
          creatorType: getUserInfo().userEntityType,
          evaluationJustification: null,
          __typename: "AssessmentToolResponse",
        };
        updatedToolResponses = [...updatedToolResponses, newResponse];
      }

      return {
        node: {
          ...data?.node,
          toolResponses: updatedToolResponses,
        },
      };
    }
  );
};

export const handleAssessmentToolResponse = ({
  rowId,
  feedbackText,
  assessmentToolId,
  parentId,
  columnId,
}) => {
  return async dispatch => {
    const userInfo = getUserInfo();
    const userEntityType = userInfo.userEntityType;
    updateToolResponseInCache({
      rowId,
      feedbackText,
      parentId,
      columnId,
    });
    try {
      await client.mutate({
        mutation: handleAssessmentToolResponseMutation,
        variables: {
          parentId,
          parentType: "PROJECT",
          rowId,
          columnId,
          subjectiveResponse: feedbackText,
          studentAssessmentEvaluationId: 123, //added at other places so keeping it
          type: "MYP_OBJECTIVE_RUBRIC",
          createdBy: userInfo.id,
          creatorType: userEntityType,
          assessmentToolId,
        },
      });
    } catch (error) {
      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg({ msg: error.message, notString: true }));
      }
    }
  };
};

export const updateToolRemarks = ({
  rowId,
  feedbackText,
  parentId,
  studentId,
}) => {
  return async dispatch => {
    let updatedData;

    const userInfo = getUserInfo();
    const createdBy = userInfo.id;
    cache.updateQuery(
      {
        query: getProjectCriteriaDetailsQuery,
        variables: { id: parentId, studentCourseFilters: {} },
      },
      data => {
        const index = _.findIndex(data?.node?.ibPYPElementRemarks, {
          ibPYPElementId: rowId,
        });

        updatedData = data;
        if (index !== -1) {
          updatedData = update(data, {
            node: {
              ibPYPElementRemarks: {
                [index]: {
                  message: {
                    $set: feedbackText,
                  },
                },
              },
            },
          });
        } else {
          updatedData = update(data, {
            node: {
              ibPYPElementRemarks: {
                $push: [
                  {
                    id: generateRandomId(),
                    ibPYPElementId: rowId,
                    ibPYPElementType: "DP_CRITERIA",
                    message: feedbackText,
                    __typename: "IBPYPElementRating",
                  },
                ],
              },
            },
          });
        }

        return updatedData;
      }
    );

    try {
      await client.mutate({
        mutation: updateElementRemarkMutationMutation,
        variables: {
          input: {
            studentId,
            parentType: "PROJECT",
            parentId,
            ibPYPElementType: "DP_CRITERIA",
            ibPYPElementId: rowId,
            createdBy,
            message: feedbackText,
          },
        },
      });
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg({ msg: e.message, notString: true }));
      }
    }
  };
};
